module.exports = {
          srcSet: __webpack_public_path__ + "33ca46ec4c98c3998b9ebeed4ceb4d9c-708.png"+" 708w",
          images:[ {path: __webpack_public_path__ + "33ca46ec4c98c3998b9ebeed4ceb4d9c-708.png",width: 708,height: 974}],
          src: __webpack_public_path__ + "33ca46ec4c98c3998b9ebeed4ceb4d9c-708.png",
          toString:function(){return __webpack_public_path__ + "33ca46ec4c98c3998b9ebeed4ceb4d9c-708.png"},
          
          width: 708,
          height: 974
        }